module.exports = __webpack_public_path__ + "63ee65d4426edbc9d67a832a402d10c2.svg";